import { render, staticRenderFns } from "./what.vue?vue&type=template&id=1cebcf44&scoped=true"
import script from "./what.vue?vue&type=script&lang=js"
export * from "./what.vue?vue&type=script&lang=js"
import style0 from "./what.vue?vue&type=style&index=0&id=1cebcf44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cebcf44",
  null
  
)

export default component.exports